import {Box, Chip, Typography} from '@mui/material';
import {Grid} from '@mui/material';
import {AppCard} from 'components/card';
import {LogDetailResponse, ModifiedItemStatusForItemDataLogModel} from 'models/logs';
import React, {useState} from 'react';
import {format} from 'date-fns';
import parser from 'html-react-parser';

import LogDetailsDialog from './LogDetailsDialog';
import {InfoCircle} from 'iconsax-react';
import {useLogsHelper} from 'hooks';
import {Tooltip} from '@mui/material';
import {AppIconButton} from 'components/buttons';

interface LogsCardProps {
    log: LogDetailResponse<ModifiedItemStatusForItemDataLogModel>;
}
export const LogsCard: React.FC<LogsCardProps> = ({log}) => {
    const [open, setOpen] = useState(false);
    const {getChipColorByLogType} = useLogsHelper();

    return (
        <Grid item xs={12}>
            <AppCard>
                <Grid container>
                    <Grid item xs={6} display={'flex'} alignItems="center">
                        <Chip
                            label={log.type}
                            sx={{mr: 1}}
                            color={getChipColorByLogType(log.type ?? 'error')}
                            size="small"
                            variant="light"
                        />
                        {log.date && (
                            <Typography variant="caption" color="secondary">
                                {format(new Date(log.date), ' MM/dd/yyyy  hh:mm a')}
                            </Typography>
                        )}
                    </Grid>
                    <Grid item xs={6} display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                        {log.data.Modification?.FieldChanges && log.data.Modification.FieldChanges.length > 0 && (
                            <Box sx={{width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
                                <Tooltip title="View Details">
                                    <AppIconButton
                                        onClick={() => setOpen(true)}
                                        sx={{fontSize: '10px'}}
                                        color="primary"
                                    >
                                        <InfoCircle />
                                    </AppIconButton>
                                </Tooltip>
                            </Box>
                        )}
                    </Grid>
                    {log.data && (
                        <Grid item xs={12}>
                            {log.type?.toLowerCase().includes('comment') ? (
                                <Box>
                                    {log.data.Modification?.PreviousStatusName && (
                                        <Typography component="div">
                                            <strong>Previous Comment: </strong> <br />
                                            {parser(log.data.Modification?.PreviousStatusName)}
                                        </Typography>
                                    )}
                                    {log.data.Modification?.NewStatusName && (
                                        <Typography component="div">
                                            <strong>New Comment: </strong>
                                            <br />
                                            {parser(log.data.Modification?.NewStatusName)}
                                        </Typography>
                                    )}
                                </Box>
                            ) : (
                                log.data.Modification && (
                                    <>
                                        {log.data.Modification.NewStatusName && (
                                            <Typography component="div">
                                                <strong>Updated Status: </strong>
                                                {log.data.Modification.NewStatusName}
                                            </Typography>
                                        )}
                                        {log.data.Modification.PreviousStatusName && (
                                            <Typography component="div">
                                                <strong>Previous Status: </strong>
                                                {log.data.Modification.PreviousStatusName}
                                            </Typography>
                                        )}
                                        {log.data.Modification.NewSprintName && (
                                            <Typography component="div">
                                                <strong>New Sprint: </strong>
                                                {log.data.Modification.NewSprintName}
                                            </Typography>
                                        )}
                                        {log.data.Modification.PreviousSprintName && (
                                            <Typography component="div">
                                                <strong>Previous Sprint: </strong>
                                                {log.data.Modification.PreviousSprintName}
                                            </Typography>
                                        )}
                                    </>
                                )
                            )}
                            {log.data.ModifiedBy && (
                                <Typography component="div">
                                    <strong>{log.type === 'Create' ? 'Created' : 'Modified'} By: </strong>
                                    {log.data.ModifiedBy}
                                </Typography>
                            )}
                        </Grid>
                    )}
                </Grid>
                {log.data.Modification && log.data.Modification.FieldChanges && (
                    <LogDetailsDialog
                        FieldsData={log.data.Modification.FieldChanges}
                        open={open}
                        onCloseDialog={() => setOpen(false)}
                    />
                )}
            </AppCard>
        </Grid>
    );
};

export default LogsCard;
